module.exports = __webpack_public_path__ + "static/media/chip-2500.f96f034a.png";